import React, { Component } from 'react';
import ReactPlayer from 'react-player';


class Video extends Component {
  render() {
    return (
      <div className="video">

        <div className="video-container">

          <ReactPlayer
            url='https://vimeo.com/259259915'
            width='100%'
            height='100%'
            className='react-player'
          />

        </div>

      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/assets/components/video.js